import { BussinessDocumentsTypeModel } from "./bussiness-documents-type.models";

export class BussinessDocumentsResolutionModel {
  bussinessDocumentsResolutionId: number = 0;
  bussinessDocumentsTypeId: number = 0;
  bussinessDocumentsType: BussinessDocumentsTypeModel = new BussinessDocumentsTypeModel()
  consecutive: number = 0;
  number: string | null = null;
  authorizeType: boolean = true;
  dateResolution: Date = new Date;
  validity: number = 0;
  prefix: string | null = null;
  initialDocument: string = '';
  finalDocument: string = '';
  technologicPassword: string | null = null;
  idNumber: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}